// extracted by mini-css-extract-plugin
module.exports = {"form":"index1_form__1jJj2","title":"index1_title__gIEg7","form-control":"index1_form-control__3RTaa","button-lg":"index1_button-lg__36S1f","error":"index1_error__231qb"};